import { Injectable, Inject } from '@angular/core';
import { Resolve } from '@angular/router';
import { MaintService } from '../service';

@Injectable({
  providedIn: 'root'
})
export class GetNewPodsfiltersResolver implements Resolve<any> {

  constructor(@Inject(MaintService) public maintService: MaintService) { }

  resolve() {
    return this.maintService.getNewPodFilters();
  }
}
